import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Sidebar } from '../shared/sidebar/sidebar';
import { RouterOutlet } from '@angular/router';
import { ToastsComponent } from '../shared/toasts/toasts';
import { SpinnerPageComponent } from '../shared/spinner-page/spinner-page.component';
import { NeadbadgeService } from '../../services/neadbadge.service';
import { ScrollToTop } from '../shared/scroll-to-top/scroll-to-top';
import { ScrollService } from '../../services/scroll.service';

@Component({
  selector: 'app-layout',
  standalone:true,
  imports: [RouterOutlet,Sidebar,SpinnerPageComponent,ToastsComponent,ScrollToTop],
  templateUrl: './layout.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Layout implements OnInit,OnDestroy{
  private readonly scrollService = inject(ScrollService);
  private readonly neadbadgeService = inject(NeadbadgeService);

  constructor(){
    this.scrollService.setVisibility(true);
  }

  ngOnInit(): void {
    this.neadbadgeService.startMonitoring();
  }

  ngOnDestroy() {
    this.scrollService.setVisibility(false);
  }
}